var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"body-content"},[_c('Header'),_c('div',{staticStyle:{"margin-top":"47px"}},[_c('router-view')],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }